import React from 'react'
import { Redirect, Switch } from 'react-router-dom'

import { EXCLUSIVE_CONTENTS, StaticScopeMetadata } from '../../lib/scope'

import DossieRoute from './DossieRoute'
import {
  DadosBasicos,
  Grupo,
  Endividamento,
  Juridico,
  Offshore,
  Operacionais,
  Patrimonio,
  RF,
  BandeiraAmarela,
  Formulario,
  MidiaDesabonadora
} from './pages'

export default function DossieRouter () {
  const isSubApp = StaticScopeMetadata.getAvailableApps().length > 1
  const hasPermission = StaticScopeMetadata.getAvailableApps().includes(
    EXCLUSIVE_CONTENTS.APPS.DOSSIER
  )
  const basePath = isSubApp ? '/dossie' : ''

  if (!hasPermission) {
    return <Redirect to='/' />
  }

  return (
    <Switch>
      <DossieRoute
        path={`${basePath}/dados-basicos`}
        component={DadosBasicos}
      />
      <DossieRoute path={`${basePath}/grupo`} component={Grupo} />
      <DossieRoute path={`${basePath}/patrimonio`} component={Patrimonio} />
      <DossieRoute
        path={`${basePath}/pontos-atencao`}
        component={BandeiraAmarela}
      />
      <DossieRoute path={`${basePath}/offshore`} component={Offshore} />
      <DossieRoute
        path={`${basePath}/endividamento`}
        component={Endividamento}
      />
      <DossieRoute path={`${basePath}/juridico`} component={Juridico} />
      <DossieRoute
        path={`${basePath}/midia-desabonadora`}
        component={MidiaDesabonadora}
      />
      <DossieRoute path={`${basePath}/operacionais`} component={Operacionais} />
      <DossieRoute path={`${basePath}/rf`} component={RF} />
      {StaticScopeMetadata.getAvailablePages().includes(
        EXCLUSIVE_CONTENTS.PAGES.FORMULARIO
      ) && (
        <DossieRoute path={`${basePath}/formulario`} component={Formulario} />
      )}
      <Redirect to={`${basePath}/dados-basicos`} />
    </Switch>
  )
}
